export const HEAP_EVENT_CLICK = 'Click - Event(s)';
export const HEAP_EVENT_LIKE_CLICK = 'Click - Event Like(s)';
